/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { useCallback, useSyncExternalStore } from 'react';

/** Checks if a media query is matched. Compatible with StyleX breakpoints. */
export function useMediaQuery(query: string): boolean {
  const cleanedQuery = query.replace('@media', '').trim(); // to make compatible with breakpoints defined using StyleX

  const subscribe = useCallback((callback: (event: MediaQueryListEvent) => void) => {
    const matchMedia = window.matchMedia(cleanedQuery);

    matchMedia.addEventListener('change', callback);

    return () => matchMedia.removeEventListener('change', callback);
  }, [cleanedQuery]);

  const getSnapshot = () => window.matchMedia(cleanedQuery).matches;

  return useSyncExternalStore(subscribe, getSnapshot);
}
